export const GET_PAYSTACK_BALANCE = "GET_PAYSTACK_BALANCE";
export const GET_PAYSTACK_BALANCE_START = "GET_PAYSTACK_BALANCE_START";
export const GET_PAYSTACK_BALANCE_FAILED = "GET_PAYSTACK_BALANCE_FAILED";
